import AIpromptEngineering from "./SubCourses/AIpromptEngineering";

// heroContent.js
const heroContent = {
  StemSection: {
    titlePart1: "Explore Our Top-Rated",
    titlePart2: "Stem Courses",
    description:
      "Empower young minds with essential problem-solving skills through engaging courses in math, coding, and technology. These hands-on programs foster creativity, critical thinking, and a strong foundation in STEM subjects.",
    buttonText: "Book a free demo lesson",
  },//
  mathpage: {
    titlePart1: "Empower Young Minds",
    titlePart2: "With Math Courses",
    description:
      "A beginner-friendly course designed to introduce young minds to the world of coding. Through interactive activities and hands-on practice, students build a solid foundation in logic, sequencing, and problem-solving.",
    buttonText: "Book a free demo lesson",
  },
  BrainTrainAbacusPage: {
    titlePart1: "Brain Train Abacus",
    titlePart2: "Unlocking Your Child's Brain Potential",
    description:
      "At POLYMATH-KIDS, we don't just teach arithmetic - we develop concentration, ideation, and confidence. Our unique approach activates both hemispheres of the brain and encourages smart, fast, calculator-free calculations.",
    buttonText: "Book a free demo lesson",
  },
  sciencepage: {
    titlePart1: "Journey Through Space",
    titlePart2: "with Polymath-Kids",
    description:
      "Exploring space has always captured the curiosity of young minds. From learning about the origins of the universe to discovering new planets, the field of space sciences offers endless opportunities for learning and wonder.",
    buttonText: "Book a free demo lesson",
  },
  astronomyPage: {
    titlePart1: "Astronomy Course",
    description:
      "At Polymath-Kids, our Astronomy program sparks curiosity and imagination while building critical thinking and problem-solving skills. With a fun, comprehensive curriculum covering the solar system, stars, galaxies, and space exploration, children gain a deeper understanding and appreciation of the universe.",
    buttonText: "Book a free demo lesson",
  },
  communicationpage: {
    titlePart1: "Empowering Young Minds to",
    titlePart2: "Speak with Confidence",
    description:
      "At Polymath-Kids, we believe strong communication is the key to success-both in academics and in life. Our Communication Skills for Kids program is thoughtfully designed to help children express themselves confidently, listen actively, and interact respectfully with others.",
    buttonText: "Book a free demo lesson",
  },
  communicationSkillsCoursePage: {
    titlePart1: "Communication Skills Course",
    description:
      "Communication Skills for Kids is an engaging program designed to help children develop essential verbal, non-verbal, and interpersonal communication skills. It empowers them to express themselves confidently, interact positively with others, and succeed in various areas of life.",
    buttonText: "Book a free demo lesson",
  },
  engineeringpage: {
    titlePart1: "Empowering Young Minds",
    titlePart2: "Through Engineering",
    description:
      "In today's rapidly advancing world, understanding engineering and technology is more important than ever. At Polymath-Kids, we offer hands-on, age-appropriate engineering courses that introduce children to real-world concepts in a fun and engaging way.",
    buttonText: "Book a free demo lesson",
  },
  CivilEngineeringPage: {
    titlePart1: "Civil Engineering Course",
    description:
      "Polymath-kids offer comprehensive online Civil Engineering course for kids. The online engineering classes' offers two modes-online 1:1 classes and online group classes with trained teachers having years of experience in Civil Engineering.",
    buttonText: "Book a free demo lesson",
  },
  architecturepage: {
    titlePart1: "Empowering Young Minds",
    titlePart2: "With Architecture Courses",
    description:
      "Interior architecture focuses more on structural design, with an emphasis on adaptive reuse and the remodelling of existing buildings. Whereas interior design is the practice of creating interior atmospheres - focusing on finishes, furniture and colour palettes.",
    buttonText: "Book a free demo lesson",
  },
  architectureInteriorDesignPage: {
    titlePart1: "Architecture & Interior Design",
    description:
      "Polymath-kids offer comprehensive online Architecture & Interior Design course for kids. The online classes' offers two modes -online 1:1 classes and online group classes with trained teachers having years of experience in Architecture & Interior Design.",
    buttonText: "Book a free demo lesson",
  },
  quranpage: {
    titlePart1: "Qur'an Learning Made Easy",
    titlePart2: "and Meaningful for Kids",
    description:
      "Being a parent is a beautiful blessing-and with it comes the sacred responsibility of nurturing your child's moral, spiritual, and emotional development. At Polymath-Kids, we believe the greatest gift you can offer your child is a strong connection to Allah Almighty through the Qur'an.",
    buttonText: "Book a free demo lesson",
  },
  islamicKnowledgePage: {
    titlePart1: "Islamic Knowledge Course",
    description:
      "Polymath-kids offer comprehensive online Islamic Knowledge course. With hundreds of fun activities (videos, quizes, projects and in-class discussions), the kids will have a fun learning experience to gain such important knowledge which will serve them for life and hereafter.",
    buttonText: "Book a free demo lesson",
  },
  codingpage: {
    titlePart1: "Build Logical Minds Through Fun",
    titlePart2: "& Interactive Coding Courses",
    description:
      "In today’s digital world, coding is more than just a technical skill—it’s a vital life skill. At Polymath-Kids, our age-appropriate and engaging coding courses empower children to build logical thinking, creativity, and problem-solving abilities, preparing them to excel in the 21st century.",
    buttonText: "Book a free demo lesson",
  },
  cppProgrammingpage: {
    titlePart1: "C++ Programming Course",
    description:
      "Polymath-kids offer comprehensive online C++ programming course, a text-based programming language. The online coding classes offers two modes -online 1:1 classes and online group classes with trained teachers having years of experience in Computer Sciences.",
    buttonText: "Book a free demo lesson",
  },
  unitygamedevpage: {
    titlePart1: "Game Development",
    titlePart2: "(Unity) Course",
    description:
      "Kids love to play interactive games and its more fun to develop your own imaginative game. Polymath-kids offer a comprehensive online course i.e. Game Development using Unity platform for kids aged 12 - 18 years.",
    buttonText: "Book a free demo lesson",
  },
  machinelearningpage: {
    titlePart1: "Machine Learning Course",
    description:
      "Polymath-kids offer comprehensive online Machine Learning course for kids aged 14 to 18 year. The online classes’ offers two modes -online 1:1 classes and online group classes with trained teachers having years of experience in Computer Sciences.",
    buttonText: "Book a free demo lesson",
  },
  androidappdevpage: {
    titlePart1: "Android App Development Course",
    description:
      "Polymath-Kids App Development Program for kids is a comprehensive course which enables them to develop and publish their own interesting and creative Apps. There are countless career opportunities for individuals proficient in app development essentials. Learning to code at an early age can help learners become experts and reap the benefits provided by technology.",
    buttonText: "Book a free demo lesson",
  },
  AIpromptEngineeringpage: {
    titlePart1: "AI - Prompt Engineering",
    description:
      "Polymath-kids offer comprehensive online AI - Prompt Engineering course. The online classes’ offers two modes -online 1:1 classes and online group classes with trained teachers having years of experience in Computer Sciences.",
    buttonText: "Book a free demo lesson",
  },
  designpage: {
    titlePart1: "Graphic Design Courses",
    titlePart2: "That Spark Creativity",
    description:
      "Graphic design is everywhere—from logos to websites—and it's a powerful way to communicate visually. Polymath-Kids’ courses make design fun and accessible for kids, helping them build creativity, problem-solving skills, and a strong foundation for future careers.",
    buttonText: "Book a free demo lesson",
  },
  businesspage: {
    titlePart1: "Empowering Young Minds ",
    titlePart2: "Through Entrepreneurship",
    description:
      "Encouraging kids to think of creative ways of doing things mean helping them come up with great business ideas. Polymath-Kids Business courses are especially designed for kids and teens (aged 9 to 16) to equip them with the knowledge required to navigate stages of Entrepreneurship with confidence.",
    buttonText: "Book a free demo lesson",
  },
  SummerCamp: {
    titlePart1: "Polymath Kids Summer ",
    titlePart2: "Camp 2025",
    description:
      "Give your child a summer filled with purpose, creativity, and growth! Polymath-Kids' Summer Camp 2025 offers an exciting one-month journey packed with STEAM-based courses, live interactive sessions, and fun-filled learning experiences tailored for children aged 6 to 16. From coding and mental math to civil engineering and design, every child will explore something new—and walk away with a certificate and memories that last a lifetime.",
    buttonText: "Book a free demo lesson",
  },
};

export default heroContent;
